import supabase from '../db'
import {writable} from 'svelte/store'

const createStore = () => {
  const session = supabase.auth.session();
  const user = supabase.auth.user();

  const {subscribe, set} = writable(user ? {event: null, session, user} : null);

  supabase.auth.onAuthStateChange((event, session) => {
    const user = supabase.auth.user();
    set(user ? {event, session, user} : null);
  })

  const logout = async () => {
    try {
      const {error} = await supabase.auth.signOut()
      if (error) return error;

      set(null);

      return null;
    }
    catch {
    }
  }

  return {
    subscribe,
    logout
  }
}

const authStore = createStore();

export default authStore;